const DpoUsneseni = {
    interval: null,
    miniformId: 'modal-miniform-doplneni-usneseni',

    convertFormToJSON: function (form) {
        let array = $(form).serializeArray();
        const json = {};
        $.each(array, function () {
            json[this.name] = this.value || "";
        });
        return json;
    },

    initOdkaz: function () {
        const tlacitko = $("#tlacitkoUsneseni");

        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function (e) {
                    e.preventDefault();
                    if ($(this).hasClass("disabled")) {
                        return;
                    }
                    window.open('https://usneseni.plzen.eu/', '_blank');
                    return false;
                }
            );
    },

    initHromadneUpravy: function () {
        const tlacitko = $("#tlacitko-doplnit-usneseni");

        if (!tlacitko.length) {
            return;
        }

        tlacitko
            .off("click")
            .on("click", function (e) {
                e.preventDefault();
                if ($(this).hasClass("disabled")) {
                    return;
                }

                const grid = $('#grid_section_i102');
                const rows = $(grid).jqGrid('getGridParam', 'selarrrow');
                if (!rows.length) {
                    Lemo_Alert.addInfo('Pro doplnění údajů označte alespoň jednu žádost', 'usneseniInfo');
                    return;
                }

                let ids = [];
                $.each(rows, function (i, id) {
                    ids.push(id);
                });

                let url = window.location.protocol + "//" + window.location.host;
                url += "/ajax/usneseni/nactiFormular";

                $.ajax({
                    type: "post",
                    url: url,
                    dataType: "json",
                    data: {'ids': ids},
                    global: true,
                    success: function (r) {
                        if (r.hasOwnProperty("messages")) {
                            Lemo_Alert.addMany(r.messages);
                        }

                        if (r.hasOwnProperty("status") && true !== r.status) {
                            return;
                        }

                        const uuid = r.data["uuid"];

                        WilleModal.setTitle('Doplnění usnesení');
                        WilleModal.setId(this.miniformId);
                        WilleModal.disableClose();
                        WilleModal.addButton(
                            "continue",
                            "<i class=\"fa fa-fw fa-check\"></i> Pokračovat",
                            "btn btn-primary",
                            function () {
                                DpoUsneseni.odesliData(uuid);
                            });
                        WilleModal.addButton("cancel",
                            "<i class=\"fa fa-fw fa-check\"></i> Zrušit",
                            'btn btn-danger',
                            function () {
                                Lemo_Alert.closeAll();
                                Promise.all([
                                    WilleModal.close()
                                ]).then(() => {
                                    Lemo_Alert.closeAll();
                                    DpoUsneseni.odemkniZadosti(uuid);
                                }).catch((messages) => {
                                    console.log(messages);
                                });
                            });
                        WilleModal.setContent(r.html);
                        WilleModal.build();
                    }
                });
            });
    },

    odemkniZadosti: function (uuid) {
        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/usneseni/odemkniZadosti";

        $.ajax({
            type: "post",
            url: url,
            dataType: "json",
            data: {"uuid": uuid},
            global: true
        });
    },

    odesliData: function (uuid) {
        const form = $("#miniform-doplneni-usneseni");
        if (!form.length) {
            return;
        }
        const formData = this.convertFormToJSON(form);
        formData["uuid"] = uuid;

        let url = window.location.protocol + "//" + window.location.host;
        url += "/ajax/usneseni/aktualizujZadosti";

        $.ajax({
            type: "post",
            url: url,
            dataType: "json",
            data: formData,
            global: true,
            beforeSend: function() {
                Lemo_Alert.closeAll();
            },
            success: function (r) {
                if (r.hasOwnProperty("messages")) {
                    Lemo_Alert.addMany(r.messages);
                }

                if (r.hasOwnProperty("status") && true !== r.status) {
                    return;
                }

                WilleModal.close();
            }
        });

    }

};

$(document).ready(function () {
    DpoUsneseni.initOdkaz();
    DpoUsneseni.initHromadneUpravy();
});